export default class Tag {

    id = null;
    name = '';
    metaInfo = '';
    metaInfoColor = null;

    constructor() {
    }
  }
